import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Api from "../../Api";
import {
  LinkNewCategoryModalForm,
  ListAppCategoryDetail,
} from "../../component";

const AppCategoryDetail = () => {
  const { appCategoryId } = useParams();
  interface CategoryDetail {
    appCategoryId: number,
    categoryId: number,
    stateId: number,
    stateName: string,
    categoryName: string
  }

  const initialState = {
    appCategoryId: Number(appCategoryId),
     categoryId: null,
     stateId: null,
  };

  interface StateType {
    stateName: string, 
    stateId: number
  }

  interface CategoryType {
    categoryName: string, 
    categoryId: number
  }

  const [categories, setCategories] = useState<CategoryDetail[]>([]);
  const [findOptions, setFindOptions] = useState(initialState);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [listCount, setListCount] = useState(0);
  const [stateOptions, setStateOptions]=useState<StateType[]>([])
  const [categoryOptions, setCategoryOptions]=useState<CategoryType[]>([])

  const api = Api();


  const resetFindOptions = () => setFindOptions({...initialState});

  const fetchForDropdown = async () => {
    const stateResponse = await api.state.getStates();
    const categoryResponse = await api.category.getCategories();
    setStateOptions([...stateResponse.states])
    setCategoryOptions([...categoryResponse.categories])

  };

  const handleCreateCategory = (payload: {categoryIds: number[], stateIds: number[]}) => {
    api.AppCategory.createAppCategoryRelationship({...payload, appCategoryId}).then((response: any) => {
      toast.success(response.message);
      getAppCategoriesRelationship();
    });
  };

  const getAppCategoriesRelationship = () => {
    api.AppCategory.searchAppCategoryRelationship({...findOptions, pageIndex, pageSize}).then((response: any)=>{
      if(response){
        setListCount(response.appCategoryRelationshipsCount);
        setCategories([...response.appCategoryRelationships])
        if(response.appCategoryRelationshipsPageIndex>1 && response.appCategoryRelationshipsPageSize === 0){
          setPageIndex(pageIndex-1)
        }
      }
    })
  };


  const onChangePageIndex = (pageNumber: number) =>
    setPageIndex(pageNumber - 1);
  const onChangePageSize = (pageSize: number) => {setPageSize(pageSize); setPageIndex(0)}
  
  const handleFind = (findOptions: any) => setFindOptions(findOptions);

    const handelDelete = (appCategoryId: number, categoryId: number, stateId: number,) => {
      api.AppCategory.deleteAppCategoryRelationship({appCategoryId,categoryId,stateId}).then((response: any)=>{
        if(response){
          toast.success(response.message);
          getAppCategoriesRelationship();
        }
      })
    };

  useEffect(() => {
    getAppCategoriesRelationship();
  }, [findOptions, pageIndex, pageSize]);

  useEffect(()=>{
    fetchForDropdown()
  },[]);

  return (
    <div className="w-100">
      <div className="float-end mx-2">
        <LinkNewCategoryModalForm
          onCreateNewCategory={handleCreateCategory}
          stateListForDropdown={stateOptions}
          categoryListForDropdown={categoryOptions}
        />
      </div>

      <ListAppCategoryDetail appCategoriesRelationshipList={categories}  
          resetFindOptions={resetFindOptions}
          findOptions={findOptions}
          stateListForDropdown={stateOptions}
          categoryListForDropdown={categoryOptions}
          handleFind={handleFind}
          handelDelete={(appCategoryId: number,categoryId: number, stateId: number, ) =>
            handelDelete(appCategoryId, categoryId, stateId, )
          }
          totalItemCount={listCount}
          pageIndex={pageIndex}
          pageSize={pageSize}
          onChangePageIndex={(pageNumber: number) =>
            onChangePageIndex(pageNumber)
          }
          onChangePageSize={onChangePageSize}
    />
    </div>
  );
};

export default AppCategoryDetail;
